const makeValidDate = date => {
  return new Date(date);
};

export default makeValidDate;
